import { render, staticRenderFns } from "./fibonacci-counter.vue?vue&type=template&id=164f33ae&scoped=true&"
import script from "./fibonacci-counter.vue?vue&type=script&lang=js&"
export * from "./fibonacci-counter.vue?vue&type=script&lang=js&"
import style0 from "./fibonacci-counter.vue?vue&type=style&index=0&id=164f33ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f33ae",
  null
  
)

export default component.exports